import React from "react";

/**
 * Highlighted "HAS" mark — used inline in any body copy or heading to make
 * the brand name visually prominent. Inherits parent text size, then scales
 * up via em-based sizing so it always looks larger than its surrounding text.
 */
export function HasMark({ className = "" }) {
  return (
    <span className={`has-mark font-display ${className}`} aria-label="HAS">
      HAS
    </span>
  );
}

/**
 * Renders the full legal company name with the "HAS" portion styled prominently.
 * Use this wherever the brand is mentioned in user-visible text.
 */
export function CompanyName({ suffix = "Universal Management Consultancy LLC", className = "" }) {
  return (
    <span className={className}>
      <HasMark /> {suffix}
    </span>
  );
}

export default HasMark;
